// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"AddDocument_AssignChecklist__fOdcD","modalBody":"AddDocument_modalBody__QILng","formControl":"AddDocument_formControl__Ayaag"};